//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {



/* Exports */
if (typeof Package === 'undefined') Package = {};
Package['ddp-rate-limiter'] = {};

})();



/*****************
 ** WEBPACK FOOTER
 ** ./build/meteor/bundle/programs/web.browser/packages/ddp-rate-limiter.js
 ** module id = ./build/meteor/bundle/programs/web.browser/packages/ddp-rate-limiter.js
 ** module chunks = 0 1
 **/